var Model = require('../Model');
var model = Object.create(Model);

model.name = 'Rest Resource';
model['@class'] = 'RestResource';
model.url = 'restresource';
model.parentClass = 'Resource';
model.isNetworkModel = true;
model.fields = {
  parent: {
    default: null,
    hidden: true
  },
  name: {
    type: 'text',
    default: null,
    validators: {
      presence: true,
      length: {minimum: 3, maximum: 128}
    }
  },
  path: {
    type: 'text',
    default: '/',
    validators : {
      presence: true
    }
  },
  arrayKey: {
    default: '',
    type: 'text',
  },
  requestType: {
    type: 'select',
    default: 'get',
    options: [
      {name: 'GET', value: 'get'},
      {name: 'HEAD', value: 'head'}
    ]
  },
  queryParams: {
    type: 'text',
    default: ''
  },
  postBody: {
    type: 'text',
    default: ''
  },
  requestHeaders: {
    default: '',
    hidden: true
  },
  bodyType: {
    default: '',
    hidden: true
  },
  timeout: {
    default: '',
    hidden: true
  },
  responseFormat: {
    default: '',
    hidden: true
  },
  allowNon2xx: {
    default: '',
    hidden: true
  },
  writeMode: {
    default: '',
    hidden: true
  },
  writeMethod: {
    default: '',
    hidden: true
  },
  writePath: {
    default: '',
    hidden: true
  },
  writeBodyType: {
    default: '',
    hidden: true
  },
  writeBody: {
    default: '',
    hidden: true
  },
  writeValueKey: {
    default: 'value',
    hidden: true
  },
  writeHeaders: {
    default: '',
    hidden: true
  },
  statusNormalValue: {
    type: 'text',
    default: ''
  },
  statusIndex: {
    type: 'text',
    default: ''
  },
  error: {
    hidden: true,
    default: ''
  },
  lastError: {
    hidden: true,
    default: ''
  },
  interval: {
    type: 'number',
    default: 0
  },
  pollGroup: {
    default : null,
    hidden: true
  },
  writable: {
    hidden: true
  },
  deleted: {
    default: false,
    hidden: true
  },
  type: {
    default: false,
    hidden: true
  },
  status: {},
  updated: {},
  polled: {},
  lastOfflineTimestamp: {},
  xml: {
    type: 'select',
    default: 0,
    options: [
      {name: 'Parse as JSON', value: 0},
      {name: 'Parse as XML', value: 1},
    ]
  },
  html: {
    type: 'select',
    default: 0,
    options: [
      {name: 'Parse as JSON', value: 0},
      {name: 'Parse as HTML', value: 1},
    ]
  },
};

module.exports = model;
